import blockquote, { blockquoteVariants, BlockquoteVariantsType } from './blockquote';
import { CSSStandardProperties } from '../../../types/theme';

export const quoteVariants = {
  blockquote: blockquoteVariants,
};

export type QuoteVariantsType = 'blockquote';

export interface QuoteType {
  /** The Accordion subcomponent types. */
  Components: Record<QuoteVariantsType, Record<BlockquoteVariantsType, CSSStandardProperties>>;
  /** The Blockquote types. */
  Blockquote: BlockquoteVariantsType;
}

const quote = {
  blockquote,
};

export default quote;
